module.exports = __webpack_public_path__ + "img/vi.c69eb3cb.png";